import AnalyticsTypes from '~/constants/types/AnalyticsTypes';
import * as DesignSelectors from '~/selectors/DesignSelectors';
import * as ProductSelectors from '~/selectors/ProductSelectors';
import * as CatalogSelectors from '~/selectors/CatalogSelectors';
import {hasSleeveImagesForProductColor} from '~/selectors/ProductSelectors';
import {isFundraisingMode} from '~/selectors/LabModeSelectors';
import {createAction} from 'redux-actions';
import {withDesignTag} from '../utils/analytics';

export const addArt = createAction(AnalyticsTypes.ADD_ART);

export const addDesign = createAction(AnalyticsTypes.ADD_DESIGN);

export const addComplement = createAction(AnalyticsTypes.ADD_COMPLEMENT);

export const addItems = createAction(AnalyticsTypes.ADD_ITEMS);

export const addItemsColor = createAction(AnalyticsTypes.ADD_ITEMS_COLOR);

export const addItemsClose = createAction(AnalyticsTypes.ADD_ITEMS_CLOSE);

export const addItemsColorClose = createAction(
  AnalyticsTypes.ADD_ITEMS_COLOR_CLOSE
);

export const addItemsPickStyle = styleId => (dispatch, getState) => {
  const action = createAction(
    AnalyticsTypes.ADD_ITEMS_PICK_STYLE,
    styleId => styleId,
    styleId => ({
      isCurrentProduct:
        styleId &&
        styleId === ProductSelectors.getErrorFreeSelectedProduct(getState())?.id
    })
  );
  dispatch(action(styleId));
};

export const addItemsQuote = createAction(AnalyticsTypes.ADD_ITEMS_QUOTE);

export const addItemsSelectColor = createAction(
  AnalyticsTypes.ADD_ITEMS_SELECT_COLOR
);

export const addItemsBrowseMore = createAction(
  AnalyticsTypes.ADD_ITEMS_BROWSE_MORE
);

export const addText = createAction(AnalyticsTypes.ADD_TEXT);

export const artBrowse = createAction(
  AnalyticsTypes.ART_BROWSE,
  (categories, categoryNames) => {
    const formatedCategoryNames = categoryNames
      .keySeq()
      .toArray()
      .reduce((acc, currentKey) => {
        acc[currentKey] = categoryNames.get(currentKey).replace('/', '_');
        return acc;
      }, {});
    const categoryNamePath = categories
      .map(c => formatedCategoryNames[c.match(/\d+/)])
      .filter(n => n !== undefined)
      .join('/')
      .replace(' ', '')
      .toLowerCase();
    return {categoryNamePath};
  }
);

export const artClose = createAction(AnalyticsTypes.ART_CLOSE);

export const artTools = createAction(AnalyticsTypes.ART_TOOLS);

export const artPalette = createAction(AnalyticsTypes.ART_PALETTE);

export const artSwap = createAction(AnalyticsTypes.ART_SWAP);

export const artChangeColor = createAction(AnalyticsTypes.ART_CHANGE_COLOR);

export const artResetColor = createAction(AnalyticsTypes.ART_RESET_COLOR);

export const buyForm = createAction(AnalyticsTypes.BUY_FORM);

export const buyWithGroup = createAction(AnalyticsTypes.BUY_WITH_GOF);

export const gofQuoteStart = createAction(
  AnalyticsTypes.BUY_WITH_GOF_QUOTE_START
);

export const gofQuoteComplete = createAction(
  AnalyticsTypes.BUY_WITH_GOF_QUOTE_COMPLETE
);

export const cancelADLeave = createAction(AnalyticsTypes.CANCEL_AD_LEAVE);

export const changeProductStart = createAction(
  AnalyticsTypes.CHANGE_PRODUCT_START
);

export const changeProductColorStart = createAction(
  AnalyticsTypes.CHANGE_PRODUCT_COLOR_START
);

export const changeTextEffect = createAction(AnalyticsTypes.CHANGE_TEXT_EFFECT);

export const changeTextOutline = createAction(
  AnalyticsTypes.CHANGE_TEXT_OUTLINE
);

export const changeTextOutlineComplete = createAction(
  AnalyticsTypes.CHANGE_TEXT_OUTLINE_COMPLETE
);

export const chat = createAction(AnalyticsTypes.CHAT);

export const colorCtaClick = createAction(AnalyticsTypes.COLOR_CTA_CLICK);

export const currentPathPageViewTag = createAction(
  AnalyticsTypes.CURRENT_PATH_PAGE_VIEW_TAG
);

export const defaultBlankTest = createAction(AnalyticsTypes.DEFAULT_BLANK_TEST);

export const discontinuedProduct = createAction(
  AnalyticsTypes.DISCONTINUED_PRODUCT
);

export const discontinuedProductColor = createAction(
  AnalyticsTypes.DISCONTINUED_PRODUCT_COLOR
);

export const enterPostalCode = createAction(AnalyticsTypes.ENTER_POSTAL_CODE);

export const startPostalCodeUpdate = createAction(
  AnalyticsTypes.START_POSTAL_CODE_UPDATE
);

export const fireRealTimePricingTags = createAction(
  AnalyticsTypes.REAL_TIME_PRICING_TEST
);

export const fontBrowseSeeMore = createAction(
  AnalyticsTypes.FONT_BROWSE_SEE_MORE
);

export const fundraisingNavigationPageview = createAction(
  AnalyticsTypes.FUNDRAISING_NAVIGATION
);

export const fundraisingCampaignClosedPageview = createAction(
  AnalyticsTypes.FUNDRAISING_CAMPAIGN_CLOSED
);

export const fundraisingModeWelcome = createAction(
  AnalyticsTypes.FUNDRAISING_MODE_WELCOME
);

export const fundraisingModeGoals = createAction(
  AnalyticsTypes.FUNDRAISING_MODE_GOALS
);

export const helpCall = createAction(AnalyticsTypes.HELP_CALL);

export const helpEmail = createAction(AnalyticsTypes.HELP_EMAIL);

export const helpFeedback = createAction(AnalyticsTypes.HELP_FEEDBACK);

export const helpMenu = createAction(AnalyticsTypes.HELP_MENU);

export const helpVisitFullSite = createAction(
  AnalyticsTypes.HELP_VISIT_FULL_SITE
);

export function labFromAD(
  path,
  title = '',
  savedDesignID = '',
  desktop = false,
  adSwapClipartId = ''
) {
  return {
    type: AnalyticsTypes.LAB_FROM_AD,
    payload: {
      path,
      title,
      savedDesignID,
      desktop,
      adSwapClipartId
    }
  };
}

export const loadWithoutDesign = () => (dispatch, getState) => {
  const state = getState();
  if (!isFundraisingMode(state)) {
    dispatch({type: AnalyticsTypes.LOAD_WITHOUT_DESIGN});
  }
};

export const mainMenuOpen = createAction(AnalyticsTypes.MAIN_MENU_OPEN);

export const mainMenuNavigate = createAction(AnalyticsTypes.MAIN_MENU_NAVIGATE);

export const namesAndNumbers = createAction(AnalyticsTypes.NAMES_AND_NUMBERS);

export const namesAndNumbersClose = createAction(
  AnalyticsTypes.NAMES_AND_NUMBERS_CLOSE
);

export const namesAndNumbersColors = createAction(
  AnalyticsTypes.NAMES_AND_NUMBERS_COLORS
);

export const namesAndNumbersGetStarted = createAction(
  AnalyticsTypes.NAMES_AND_NUMBERS_GET_STARTED
);

export const namesAndNumbersPosition = createAction(
  AnalyticsTypes.NAMES_AND_NUMBERS_POSITION
);

export const namesAndNumbersList = createAction(
  AnalyticsTypes.NAMES_AND_NUMBERS_LIST
);

export const namesAndNumbersAlert = createAction(
  AnalyticsTypes.NAMES_AND_NUMBERS_ALERT
);

export const namesAndNumbersComplete = createAction(
  AnalyticsTypes.NAMES_AND_NUMBERS_COMPLETE
);

export const namesAndNumbersEdit = createAction(
  AnalyticsTypes.NAMES_AND_NUMBERS_EDIT
);

export const ndxBreakpoint = createAction(AnalyticsTypes.NDX_BREAKPOINT);

export function ndxStart() {
  return function (dispatch, getState) {
    const state = getState();
    const isDirty = DesignSelectors.isDirty(state);
    const withDesign = withDesignTag(isDirty);
    const colorId = ProductSelectors.getCurrentColorId(state);
    const anchorStyleId = ProductSelectors.getAnchorStyleId(state);
    const style = CatalogSelectors.getStyle(state, {styleId: anchorStyleId});
    const designIdeaId = DesignSelectors.getDesignIdeaId(state);
    const productColor = ProductSelectors.getSelectedProductColor(state);
    dispatch({
      type: AnalyticsTypes.NDX_START,
      payload: {
        anchorStyleId,
        withDesign: withDesign,
        categoryName: style?.primary_category_name,
        colorId,
        designIdeaId,
        productColor: productColor?.name
      }
    });
  };
}

export const next = createAction(AnalyticsTypes.NEXT);

export const nextFull = createAction(AnalyticsTypes.NEXT_FULL);

export const nextGOF = createAction(AnalyticsTypes.NEXT_GOF);

export const notes = createAction(AnalyticsTypes.NOTES);

export const notesAdded = createAction(AnalyticsTypes.NOTES_ADDED);

export const nextFundraiser = createAction(AnalyticsTypes.NEXT_FUNDRAISING);

export const orderMore = createAction(AnalyticsTypes.ORDER_MORE);

export const orderMoreAddStyles = createAction(
  AnalyticsTypes.ORDER_MORE_ADD_STYLES
);

export const orderMoreAddItemsAddStyles = createAction(
  AnalyticsTypes.ORDER_MORE_ADD_ITEMS_ADD_STYLES
);

export const orderMoreStylesAdded = createAction(
  AnalyticsTypes.ORDER_MORE_STYLES_ADDED
);

export const orderMoreQuoteAddStyles = createAction(
  AnalyticsTypes.ORDER_MORE_QUOTE_ADD_STYLES
);

export const printThis = createAction(AnalyticsTypes.PRINT_THIS);

export const productCatalog = createAction(AnalyticsTypes.PRODUCT_CATALOG);

export const productColor = createAction(AnalyticsTypes.PRODUCT_COLOR);

export const productColorChangeAccepted = createAction(
  AnalyticsTypes.PRODUCT_COLOR_CHANGE_ACCEPTED
);

export const productColorChangeCancelled = createAction(
  AnalyticsTypes.PRODUCT_COLOR_CHANGE_CANCELLED
);

export const productColorNotChanged = createAction(
  AnalyticsTypes.PRODUCT_COLOR_NOT_CHANGED
);

export const productColorChanged = createAction(
  AnalyticsTypes.PRODUCT_COLOR_CHANGED
);

export const productColorToggleChanged = createAction(
  AnalyticsTypes.PRODUCT_COLOR_TOGGLE_CHANGED
);

export const productDetails = createAction(AnalyticsTypes.PRODUCT_DETAILS);

export const productPrintArea = createAction(AnalyticsTypes.PRODUCT_PRINT_AREA);

export const productSummary = createAction(AnalyticsTypes.PRODUCT_SUMMARY);

export const productSummaryCarousel = createAction(
  AnalyticsTypes.PRODUCT_SUMMARY_CAROUSEL
);

export const productSummaryTag = createAction(
  AnalyticsTypes.PRODUCT_SUMMARY_TAG
);

export const productWelcomeTag = createAction(AnalyticsTypes.PRODUCT_WELCOME);

export const quoteBlankDesign = createAction(AnalyticsTypes.QUOTE_BLANK_DESIGN);

export const quoteForm = createAction(AnalyticsTypes.QUOTE_FORM);

export const quoteFormPostalChange = createAction(
  AnalyticsTypes.QUOTE_FORM_POSTAL_CODE_CHANGE
);

export const quoteFormStart = createAction(AnalyticsTypes.QUOTE_FORM_START);

export const quoteStateChange = createAction(AnalyticsTypes.QUOTE_STATE_CHANGE);

export const quoteWcibmo = createAction(AnalyticsTypes.QUOTE_WCIBMO);

export const realTimePriceChange = createAction(
  AnalyticsTypes.REAL_TIME_PRICE_CHANGE
);

export const realTimePriceQuantityChange = createAction(
  AnalyticsTypes.REAL_TIME_PRICE_QUANTITY_CHANGE
);

export const saveAddCartAttempt = createAction(
  AnalyticsTypes.SAVE_ADD_CART_ATTEMPT
);

export const saveAddCart = createAction(AnalyticsTypes.SAVE_ADD_CART);

export const saveForm = createAction(AnalyticsTypes.SAVE_FORM);

export const selectFont = createAction(AnalyticsTypes.SELECT_FONT);

export const shareEmail = createAction(AnalyticsTypes.SHARE_EMAIL);

export const shareFacebook = createAction(AnalyticsTypes.SHARE_FACEBOOK);

export const shareLink = createAction(AnalyticsTypes.SHARE_LINK);

export const sharePinterest = createAction(AnalyticsTypes.SHARE_PINTEREST);

export const shareTwitter = createAction(AnalyticsTypes.SHARE_TWITTER);

export const singlesPricingMessageTest = createAction(
  AnalyticsTypes.SINGLES_PRICING_MESSAGE_TEST
);

export const sleeveErrorFundraising = createAction(
  AnalyticsTypes.SLEEVE_ERROR_FUNDRAISING
);

export const swapProductWarning = createAction(
  AnalyticsTypes.SWAP_PRODUCT_WARNING
);

export const sleevePrintRemoveDesign = createAction(
  AnalyticsTypes.SLEEVE_PRINT_REMOVE_DESIGN
);

export const sleevePrintUndoRemoveDesign = createAction(
  AnalyticsTypes.SLEEVE_PRINT_UNDO_REMOVE_DESIGN
);

export const sleeveErrorGOF = createAction(AnalyticsTypes.SLEEVE_ERROR_GOF);

export const sleevePrintModal = createAction(AnalyticsTypes.SLEEVE_PRINT_MODAL);

export const sleevePrintActions = createAction(
  AnalyticsTypes.SLEEVE_PRINT_ACTIONS
);

export const sleevePrintNoSleeveImageSelectedProduct = createAction(
  AnalyticsTypes.SLEEVE_PRINT_NO_SLEEVE_IMAGE_SELECTED_PRODUCT
);

export const attemptFireNoSleeveImagesTag = () => (dispatch, getState) => {
  const state = getState();

  if (!hasSleeveImagesForProductColor(state)) {
    dispatch(sleevePrintNoSleeveImageSelectedProduct());
  }
};

export const sleevePrintPriceInfo = createAction(
  AnalyticsTypes.SLEEVE_PRINT_PRICE_INFO
);

export const subtletyCheck = createAction(AnalyticsTypes.SUBTLETY_CHECK);

export const textEdit = createAction(AnalyticsTypes.TEXT_EDIT);

export const textEffectDone = createAction(AnalyticsTypes.TEXT_EFFECT_DONE);

export const textEffectIntensity = createAction(
  AnalyticsTypes.TEXT_EFFECT_INTENSITY
);

export const textFontBrowse = createAction(AnalyticsTypes.TEXT_FONT_BROWSE);

export const textFontBrowseCategories = createAction(
  AnalyticsTypes.TEXT_FONT_BROWSE_CATEGORIES
);

export const textOutlineIntensity = createAction(
  AnalyticsTypes.TEXT_OUTLINE_INTENSITY
);

export const textOutlineColor = createAction(AnalyticsTypes.TEXT_OUTLINE_COLOR);

export const textOutlineOn = createAction(AnalyticsTypes.TEXT_OUTLINE_ON);

export const textOutlineOff = createAction(AnalyticsTypes.TEXT_OUTLINE_OFF);

export const textStart = createAction(AnalyticsTypes.TEXT_START);

export const textSearch = createAction(AnalyticsTypes.TEXT_SEARCH);

export const textTools = createAction(AnalyticsTypes.TEXT_TOOLS);

export const uploadXPStart = createAction(AnalyticsTypes.UPLOAD_START);

export const uploadAdd = createAction(AnalyticsTypes.UPLOAD_ADD);

export const uploadCloseTools = createAction(AnalyticsTypes.UPLOAD_CLOSE_TOOLS);

export const uploadContactUs = createAction(AnalyticsTypes.UPLOAD_CONTACT_US);

export const uploadChangeColor = createAction(
  AnalyticsTypes.UPLOAD_CHANGE_COLOR
);

export const uploadLearnMore = createAction(AnalyticsTypes.UPLOAD_LEARN_MORE);

export const uploadRecent = createAction(AnalyticsTypes.UPLOAD_RECENT);

export const uploadRemoveColors = createAction(
  AnalyticsTypes.UPLOAD_COLOR_REMOVAL
);

export const uploadResetColor = createAction(AnalyticsTypes.UPLOAD_RESET_COLOR);

export const uploadSuccess = createAction(AnalyticsTypes.UPLOAD_SUCCESS);

export const uploadToggleBackground = createAction(
  AnalyticsTypes.UPLOAD_TOGGLE_BACKGROUND
);

export const uploadToggleProductColor = createAction(
  AnalyticsTypes.UPLOAD_TOGGLE_PRODUCT_COLOR
);

export const uploadOrBrowseArt = createAction(
  AnalyticsTypes.UPLOAD_OR_BROWSE_ART
);

export const viewAllFontCategories = createAction(
  AnalyticsTypes.VIEW_ALL_FONT_CATEGORIES
);

export const waysToOrderLoad = createAction(AnalyticsTypes.WTO_OPTION_LOAD);

export const waysToOrderOptionUpdate = createAction(
  AnalyticsTypes.WTO_OPTION_UPDATE
);

export const welcome = createAction(AnalyticsTypes.WELCOME);

export const welcomeBack = createAction(AnalyticsTypes.WELCOME_BACK);

export const welcomeBackContinue = createAction(
  AnalyticsTypes.WELCOME_BACK_CONTINUE
);

export const welcomeBackNew = createAction(AnalyticsTypes.WELCOME_BACK_NEW);

export const zoomIn = createAction(AnalyticsTypes.ZOOM_IN);

export const zoomOut = createAction(AnalyticsTypes.ZOOM_OUT);
